import Vue from "vue";
import Router2 from "vue-router";
import routeRes from "./mapping";
import browser from "../utils/browser";
import store from "../store";
// import { Dialog } from 'vant'
import wx from "weixin-js-sdk";

const queryParamConvert = function(param, key, encode) {
  if (param === null) return "";
  var paramStr = "";
  var t = typeof param;
  if (t === "string" || t === "number" || t === "boolean") {
    paramStr +=
      "&" +
      key +
      "=" +
      (encode == null || encode ? encodeURIComponent(param) : param);
  } else {
    for (var i in param) {
      var k =
        key == null
          ? i
          : key + (param instanceof Array ? "[" + i + "]" : "." + i);
      paramStr += queryParamConvert(param[i], k, encode);
    }
  }
  return paramStr;
};
class Router extends Router2 {
  constructor(props) {
    // eslint-disable-line

    super(props);
  }
  goto(location) {
    let router = this;

    if (browser.versions.weChat) {
      wx.miniProgram.getEnv(res => {
        if (res.miniprogram === true) {
          // alert(location.path)
          console.log("-------走到这里了吗");
          router.push(location);
          return;
        } else {
          router.push(location);
        }
      });
      return;
    }
    console.log("---", location);
    router.push(location);
  }
  replaceto(location) {
    if (browser.versions.weChat) {
      wx.miniProgram.getEnv(res => {
        if (res.miniprogram === true) {
          // alert(location)
          router.replace(location);
          return;
        } else {
          router.replace(location);
        }
      });
    } else {
      router.replace(location);
    }
  }
  // 底部跳转
  navigateTo(location) {
    if (browser.versions.weChat) {
      wx.miniProgram.getEnv(res => {
        if (res.miniprogram === true) {
          // alert(location)
          router.replace(location);
          return;
        } else {
          router.replace(location);
        }
      });
    } else {
      router.replace(location);
    }
  }

  // 返回上一个界面
  goBack() {
    if (browser.versions.weChat) {
      wx.miniProgram.getEnv(res => {
        if (res.miniprogram === true) {
          //小程序
          console.log("------返回上一个界面");
          wx.miniProgram.navigateBack({ delta: 1 });
        } else {
          //微信浏览器
          console.log("location---", location);
          router.replace(location);
        }
      });
      return;
    }
    //H5
    window.history.go(-1);
  }
}
Vue.use(Router);
let isKeepAlive = [];
let routeConfigs = [];
routeRes.forEach(item => {
  if (item.redirect) {
    routeConfigs.push({
      path: item.path,
      redirect: item.redirect,
      meta: {
        whiteList: item.whiteList
      }
    });
  } else {
    routeConfigs.push({
      path: item.path,
      children: item.children,
      meta: {
        name: item.name,
        keepAlive: isKeepAlive.indexOf(item.path) !== -1,
        whiteList: item.whiteList
      },
      component: resolve => require(["../views" + item.h5Uri + ".vue"], resolve)
    });
  }
});

let router = new Router({
  routes: [...routeConfigs]
  // mode: "history" // 去#
});
let flag = false;
const token = localStorage.getItem("token");

router.beforeEach(async (to, from, next) => {
  const isInMiniProgram = await Vue.prototype.$isInMiniProgram;
  if (isInMiniProgram && to.path == "/login" && flag) {
    wx.miniProgram.navigateBack({ delta: 1 });
    flag = false;
    return;
  }
  console.log("store", store.state.token);
  let whiteList = ["/login"];
  window.scrollTo(0, 0);
  if (whiteList.includes(to.path)) {
    console.log("444");
    next();
  } else {
    console.log("3333");
    // if (store.state.token || token) {
    //   flag = true;
    //   next();
    // } else {
    //   next("/login");
    // }
    next()
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js